'use strict';

(function (global) {
  /**
   * Функции отвечающие за работу с задачами.
   * @namespace Core.tasks
   * @since 5.5.0.2201
   */
  global.tasks = {};
})(window.Core);

(function (global) {

  /**
   * Инициализация кнопки выбора ТМ в поле маршрута.
   * @since 5.5.0.1000
   */
  global.initSelectStandardRouteButton = function () {
    var jRoute = $('#CardContrrolRoute');
    if (jRoute.length === 0) {
      // Когда ТМ выбран будет другой контрол.
      jRoute = $('#CardContrrolStandartRoute');
    }
    jRoute = jRoute.closest('.reference_requisite');

    var jAdditionalIcons = jRoute.find('.Req_AdditionalIcons');

    if (!jAdditionalIcons.children('.task-card__select-standard').length) {

      var jSelectStandardRoute = $('<p class="task-card__select-standard-route" title="' + L('TASK_ROUTE_SELECT_STANDARD_ROUTE') + '"></p>');

      if (WA.CR.State !== WORK_STATE.INIT) {
        // У стартованной задачи нельзя поменять ТМ -- убираем кнопку
        jSelectStandardRoute.parent().remove();
      } else {
        jSelectStandardRoute.on('click', function () {
          ChangeStandartRoute();
        });

        // Удаляем все иконки внутри, т.к. они бесполезны с данным справочником (ТМ).
        jAdditionalIcons.find('p').remove();

        // Добавляем новую иконку для выбор ТМ.
        jAdditionalIcons
          .append(jSelectStandardRoute)
          .show();
      }
    }

    return global;
  };

  /**
   * Отписаться от событий изменения jQuery-контролов.
   *
   * @function unbindButtonsEnabling
   * @memberOf Core.tasks
   * @since 5.7.0
   */
  global.unbindButtonsEnabling = () => {
    const inputsWithBindings = $('.card-tab-container__main').find('input').not('.refField');
    if (inputsWithBindings) {
      inputsWithBindings.unbind('change keyup');
    }
  };

  /**
   * Установить доступность кнопок на ленте для задач.
   * @since 5.5.0.2201
   */
  global.bindButtonsEnabling = function () {
    if (!WA.CR.IsNew) {
      var toolBarButtons = WA.CR.toolBar.buttons;
      var isBindNeeded = !(toolBarButtons.isExist('TaskChange') && !toolBarButtons.TaskChange.isSelected());
      if (isBindNeeded) {
        Core.customWorks.bindButtonsEnabling('textarea.Card_Task_EditText');

        var toolBarButtonNames = ['TaskHighImp', 'TaskLowImp'];
        var enableButtonNames = ['Save'];
        toolBarButtonNames.forEach(function (buttonName) {
          var toolBarButton = toolBarButtons[buttonName];
          if (toolBarButton) {
            toolBarButton.bind('click', function () {
              Core.cards.enableButtonsOnFormChange(enableButtonNames);
            });
          }
        });

        const inputsWithBindings = $('.card-tab-container__main').find('input').not('.refField');
        inputsWithBindings.one('change keyup', function() {
          Core.cards.enableButtonsOnFormChange(enableButtonNames);
        });
      }
    }

    return global;
  };

  /**
    * Создаёт копию задачи и открывает её карточку в отдельной вкладке.
    * @param {int} sourceTaskId Идентификатор исходной задачи.
    * @since 5.8.1.9000
  */
  global.createTaskCopy = function (sourceTaskId) {
    WA.SRV.call('Task.asmx/CreateTaskCopy', { SourceTaskID: sourceTaskId }).done((result) => {
      var newTaskLink = new WA.Link(result, OBJECT_TYPE.TASK);
      newTaskLink.open();
    });
  };

  /**
    * Создаёт копии задач и открывает их карточку в отдельных вкладках.
    * @param {int} sourceTaskId Идентификатор исходной задачи.
    * @since 5.8.1.9000
  */
  global.createTaskCopies = function (sourceTasks) {
    if (!!sourceTasks) {
      for (i = 0; i < sourceTasks.length; ++i) {
        if (sourceTasks[i].kind === 'TASK') {
          Core.tasks.createTaskCopy(sourceTasks[i].id);
        }
      }
    }
  };

})(window.Core.tasks);
